import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { MicrolinkBaseClass } from "../../helpers/microlink";

var Twitter = /*#__PURE__*/function (_MicrolinkBaseClass) {
  _inherits(Twitter, _MicrolinkBaseClass);

  var _super = _createSuper(Twitter);

  function Twitter() {
    var _this;

    _classCallCheck(this, Twitter);

    _this = _super.apply(this, arguments);
    _this.name = "twitter";
    _this.icon = "<svg aria-hidden=\"true\" viewbox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M81 232A148 148 0 00230 76c10-8 19-17 26-27-9 4-20 7-30 8 11-7 19-17 23-29-10 6-21 10-33 13a52 52 0 00-90 47C82 86 44 65 18 34a52 52 0 0016 70c-9-1-17-3-24-7v1c0 25 18 47 42 51a53 53 0 01-23 1c6 21 26 36 49 37a105 105 0 01-78 21c23 15 51 24 81 24\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>";
    _this.color = "#1da1f2";
    _this.exampleURL = "https://twitter.com/elninoict/status/1106176415622418433";

    _this.validator = function (input) {
      return /(https?:\/\/(.+?\.)?(twitter|t)\.(co|com)(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/.test(input);
    };

    return _this;
  }

  return Twitter;
}(MicrolinkBaseClass);

export { Twitter as default };